import { Link } from "gatsby"
import NavLink from "./navLink"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { useMobile } from "../hooks"
import LogoExindeco from "../images/exindeco-logo.svg"

const Header = ({ siteTitle }) => (
  <header className="">
    <Menu />
  </header>
)

const Menu = () => {
  const [isOpen, setIsOpen] = useState(false)
  const isMobile = useMobile()
  return (
    <nav className="bg-white" role="navigation">
      <div className="px-4 pt-5 flex flex-wrap items-center md:flex-no-wrap">
        <div className="flex items-center mr-4 md:mr-8">
          <div className="flex flex-wrap items-center">
            <Link to="/">
              <LogoExindeco className="w-32" />
            </Link>
            <a
              href="https://goo.gl/maps/6TH6gnK2LFmernPG8"
              className="text-sm ml-5 flex items-center w-20 sm:w-auto"
              target="_blank"
            >
              <i className="material-icons-outlined mr-2"> location_on </i>
              Trouvez notre magasin
            </a>
          </div>
        </div>
        <div className="ml-auto md:hidden">
          <button
            className="flex items-center px-3 py-2 border rounded"
            type="button"
            onClick={() => setIsOpen(!isOpen)}
          >
            <svg
              className="h-3 w-3"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>
        </div>
        <div className="w-full md:w-auto md:flex-grow md:flex md:items-center">
          {isMobile ? isOpen && <ListMenu /> : <ListMenu />}
        </div>
      </div>
    </nav>
  )
}

const ListMenu = () => (
  <ul className="flex flex-col mt-4 -mx-4 pt-4 border-t md:flex-row md:items-center md:mx-0 md:ml-auto md:mt-0 md:pt-0 md:border-0">
    <NavLink title="Services" to="/Services/" />
    {/* <NavLink title="Inspiration" to="/Inspiration/" /> */}
    <NavLink title="Contactez-nous" to="/Contact/" />
  </ul>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
